<template>
  <base-section id="theme-features">
    <base-section-heading title="ERP">
      이제  판매만 신경쓰십시오! 초간편 상품 소싱, 재고 동기화, 판매 관리 배송까지 한 번에
      엘티엘가 도와드립니다.
      구매대행 및 물류대행 서비스를 기반으로 한 상품아이템 소싱, 마켓대량전송, 주문대량 수집이 가능 합니다.
    </base-section-heading>

    <v-container>
      <v-row>
        <v-col
          v-for="(feature, i) in features"
          :key="i"
          cols="12"
          md="6"
        >
          <base-avatar-card
            v-bind="feature"
            align="left"
            horizontal
          >
            {{feature.txt}}
          </base-avatar-card>
        </v-col>
      </v-row>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionThemeFeatures',

    data: () => ({
      features: [
        {
          color: '#00BCD4',
          title: '상품아이템수집', // 智能采集
          dark: true,
          icon: 'mdi-download',
          txt: 'taobao,tmall 해외 사이트에서 아이템을 찾습니다. URL만 입력하시면 해당 아이템을 정보를 가져오고 편집 가능합니다.' // 支持天猫、淘宝商品信息的采集和管理。
        },
        {
          color: '#009688',
          dark: true,
          title: '마켓등록', // 上传发布
          icon: 'mdi-arrow-up-bold-box-outline',
          txt: '수집한 상품아이템 판매를 위해 coupang,11st에 정보를 전송합니다.' // 一键上传至Coupang、11街等韩国主流电商平台。
        },
        {
          color: '#E91E63',
          dark: true,
          title: '상품 이미지 편집', // 图片编辑
          icon: 'mdi-pencil-box-outline',
          txt: '수집되 이미지 편집해서 마켓에 등록가능' // 支持在线编辑修改图片、添加文字、裁剪、涂抹等操作。
        },
        {
          color: '#F44336',
          dark: true,
          title: '상품 이미지 번역', // 图片翻译
          icon: 'mdi-image-size-select-actual',
          txt: '수집되 이미지 번역해서 마켓에 등록가능' // 将图片上的中文直接翻译成韩语，快捷方便。
        }
      ],
    }),
  }
</script>
